module.exports = __webpack_public_path__ + "img/homeLogo.07ac6262.png";